
const common = {
  // Navigation
  brand_story: "品牌故事",
  our_philosophy: "我们的哲学", 
  product_series: "产品系列",
  global_sourcing: "全球溯源",
  start_journey: "开启旅程",
  
  // Hero Section
  hero_title: "重塑年轻的",
  hero_title_highlight: "权力",
  hero_description: "LunaKey 提供大自然最有效的超级食品，经过科学制作，融入您的日常仪式中，让您焕发光彩和永恒的活力。",
  hero_cta: "开启你的旅程",
  
  // Story Section
  story_title: "从神话到现代",
  story_subtitle: "从传说到现实",
  story_description_1: "在古老的传说中，露娜女神与灵鹿共舞于月光之下，守护着自然的秘密与生命的活力。这份神话般的力量，如今通过现代科学的精准提炼，化作您手中的每一份LunaKey产品。",
  story_description_2: "我们秉承\"自然赋能，科学确权\"的理念，将全球最珍贵的超级食物，通过严谨的科学工艺，转化为您日常生活中的活力源泉。",
  story_quote: "我们并非对抗时间，而是重塑你在时间中感受年轻的权利。",
  
  // Philosophy Section
  philosophy_title: "我们的哲学",
  philosophy_subtitle: "三位一体的价值体系，构建您的健康生活方式",
  natures_proof: "自然凭证",
  natures_proof_subtitle: "自然的凭证",
  natures_proof_description: "全球采购的高效超级食物，零人工添加。每一份产品都承载着大自然最纯粹的力量，经过严格筛选与科学验证。",
  empowered_confidence: "被赋能的自信",
  empowered_confidence_subtitle: "被赋能的自信",
  empowered_confidence_description: "感受掌控自身健康带来的从容与安心。当您选择LunaKey，您选择的是对自己最好的投资与关爱。",
  your_vitality: "你的活力，你的权利",
  your_vitality_subtitle: "你的活力，你的权利",
  your_vitality_description: "一份关于主动自我关怀与健康主权的宣言。您有权拥有最好的状态，有权感受生命的无限活力。",
  
  // Products Section
  products_title: "你的权利，在此重塑",
  products_subtitle: "两大产品系列，为您的健康与美丽提供全方位支持",
  proof_series: "权利凭证系列",
  proof_series_subtitle: "权利凭证系列",
  proof_series_description: "精选全球顶级超级食物，为您的健康提供最有力的证明。每一份产品都经过严格的品质把控，确保您获得最纯净的营养补充。",
  declaration_series: "能量宣言系列",
  declaration_series_subtitle: "能量宣言系列",
  declaration_series_description: "专为现代生活方式设计的能量补充方案，让您在忙碌的日常中依然保持最佳状态，展现内在的光彩与活力。",
  acai_powder: "巴西莓粉",
  acai_description: "富含抗氧化剂，提升免疫力",
  white_tomato: "白番茄粉",
  white_tomato_description: "天然美白，焕发肌肤光彩",
  glow_booster: "光彩焕发精华",
  glow_description: "内外兼修，绽放自然光彩",
  energy_elixir: "能量精华液",
  energy_description: "持续能量，激发无限潜能",
  learn_more: "了解更多",
  
  // Sourcing Section
  sourcing_title: "循鹿所寻",
  sourcing_subtitle: "跟随灵鹿的足迹，探寻全球最珍贵的超级食物原产地",
  brazil: "巴西",
  brazil_ingredient: "巴西莓",
  brazil_description: "来自亚马逊雨林深处的紫色宝石，富含花青素和抗氧化剂，是大自然赐予的青春密码。",
  peru: "秘鲁",
  peru_ingredient: "玛卡根",
  peru_description: "安第斯山脉高原上的能量之源，千年来被誉为\"秘鲁人参\"，为身体注入持久活力。",
  himalaya: "喜马拉雅",
  himalaya_ingredient: "枸杞",
  himalaya_description: "世界屋脊上的红色珍宝，在极地环境中孕育出的超强生命力，滋养身心的天然良药。",
  mediterranean: "地中海",
  mediterranean_ingredient: "橄榄叶",
  mediterranean_description: "地中海阳光下的绿色精华，承载着千年的健康智慧，为现代生活带来纯净的守护。",
  
  // Newsletter Section
  newsletter_title: "接收你的活力焕新指南",
  newsletter_description: "订阅我们的专属内容，获取最新的健康资讯、产品更新和专业的营养建议，开启您的活力之旅。",
  email_placeholder: "您的邮箱地址",
  subscribe: "订阅",
  subscribing: "订阅中...",
  subscribe_success: "订阅成功！感谢您加入LunaKey大家庭。",
  subscribe_error: "订阅失败，请稍后重试。",
  privacy_notice: "我们承诺保护您的隐私，不会向第三方分享您的信息。您可以随时取消订阅。",
  
  // Footer
  quality_assurance: "品质保证",
  about_us: "关于我们",
  contact_us: "联系我们",
  careers: "招贤纳士",
  faq: "常见问题",
  user_guide: "使用指南",
  customer_service: "客户服务", 
  return_policy: "退换政策",
  footer_description: "夺回年轻的权利，让大自然最有效的超级食品融入您的日常仪式，焕发光彩和永恒的活力。",
  all_rights_reserved: "保留所有权利",
  privacy_policy: "隐私政策",
  terms_of_service: "服务条款"
};

export default common;
